import React, {Component} from 'react';
import i18n from '../../i18n';
import config from '../../config';
import {withTranslation} from 'react-i18next';
import {Loading, NotFoundError, SubHeading, withRouter} from "cw-styleguide-react";
import {GelContentContainer} from "cw-styleguide-react";
import {HeroBlock, StyleguideContext} from "cw-styleguide-react";
import {BreadcrumbsItem} from "react-breadcrumbs-dynamic";
import axios from "axios";
import Helmet from 'react-helmet';

class NewsDetailView extends Component {
 

  render() {

    return (
      <div>
        <Helmet>
          <title>{this.props.news.title} | {this.props.t('local:news')}</title>
          <meta name={'description'} content={this.props.t('local:metaDescription')}/>
        </Helmet>
        <BreadcrumbsItem to={this.props.news.alias}>
          {this.props.news.title}
        </BreadcrumbsItem>
        <GelContentContainer>
          <SubHeading type='sub-heading-small' colour={'sub-heading-small--grey'}>{this.props.t('local:news')}</SubHeading>
          <h1 style={{marginTop: '-15px'}}>{this.props.news.title}</h1>
        </GelContentContainer>
        <HeroBlock meta={!this.props.news.hideDate ? [{
          key: this.props.t('local:first_published') + ':',
          value: this.props.news.published.long
        }] : []}>
          <div dangerouslySetInnerHTML={{__html: this.props.news.description}}/>
        </HeroBlock>
        <GelContentContainer>
          <div className={'gel-md-mb-40 gel-lg-mb-40 gel-xl-mb-40'} dangerouslySetInnerHTML={{__html: this.props.news.body}}></div>
        </GelContentContainer>
      </div>
    );
  }
}

NewsDetailView.contextType = StyleguideContext;
export default withTranslation('remote')(withRouter(NewsDetailView));